import React, { useState } from 'react';
import { FaXmark } from 'react-icons/fa6';

export default function ModalFinalizaAcompanhamento({ submit, close}) {
  const [res, setRes] = useState({
    observacao: '',
    status: 'EM_ANDAMENTO',
    alteradoEm: new Date().getTime(),
  })

  const handleChange = (e) => setRes({...res, [e.target.name]: e.target.value})

  return (
    <div className='fixed w-full h-full flex items-center justify-center bg-secondary z-50 top-0 bg-opacity-60 '>
      <div className='bg-white w-2/3 max-h-[80%] rounded p-8 overflow-y-auto'>
        <div className='flex gap-3 flex-col'>
          <div className='flex justify-between items-center text-primary text-xl'>
            <h1 className='font-semibold'>Alterar situação do acompanhamento</h1>
            <span className='hover:cursor-pointer' onClick={() => close(false)}><FaXmark /></span>
          </div>
          <span className='font-semibold text-primary'>Observação:</span>
          <textarea
            name="observacao"
            id=""
            cols="30"
            rows="10"
            onChange={(e) => handleChange(e)}
            className='border-secondary border-2 p-2 rounded outline-primary'
          ></textarea>
          <div className='flex flex-col gap-2'>
          <span className='font-semibold text-primary'>Status:</span>
            <select name="status" id="status" className='border-2 border-secondary rounded px-2 py-1 outline-primary text-primary' onChange={(e) => handleChange(e)}>
              <option value="EM_ANDAMENTO">Em andamento</option>
              <option value="NAO_REALIZADO">Não realizado</option>
              <option value="FINALIZADO">Concluido</option>
            </select>
          </div>
          <div className='flex justify-end'>
            <button className='bg-primary text-white px-4 py-2 rounded' onClick={() => submit(res)}>Enviar</button>
          </div>
        </div>
      </div>
    </div>
  )
};
